import { BackgroundProps } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { finleyAssert } from '@finley-technologies/common';

import { Select } from 'packages/common-frontend/components/Select';
import { useLoanProductCreditFacilityGroupContext } from 'packages/loanProduct/hooks/LoanProductCreditFacilityGroupingProvider';
import {
  LoanProduct,
  useLoanProductForLpCfGroupingContext,
} from 'packages/loanProduct/hooks/LoanProductForLpCfGroupingContext';

/**
 * # ⚠️ WARNING
 * ## Not to be used on it's own as a LP select!
 * To be used with
 * - `LoanProductCreditFacilityGroupContext`
 * - `LoanProductForLpCfGroupingContext`
 */
export const LoanProductSelect: React.FC<{
  inputFloatingLabelBackgroundColor: BackgroundProps['bgColor'];
}> = ({ inputFloatingLabelBackgroundColor }) => {
  const { lpToCfEntityGrouping } = useLoanProductCreditFacilityGroupContext();
  const {
    loanProduct,
    setLoanProduct,
  } = useLoanProductForLpCfGroupingContext();

  const options = useMemo(() => {
    if (!lpToCfEntityGrouping) return [];
    return lpToCfEntityGrouping.loanProducts.map(
      ({ id, name }: LoanProduct) => ({
        label: name,
        value: id,
      }),
    );
  }, [lpToCfEntityGrouping]);

  return (
    <Select
      inputFloatingLabel="Loan Product"
      inputFloatingLabelBackgroundColor={inputFloatingLabelBackgroundColor}
      options={options}
      value={loanProduct.id}
      onChange={(newLoanProductId?: string) => {
        if (newLoanProductId) {
          const newLoanProduct = lpToCfEntityGrouping.loanProducts.find(
            ({ id }) => id === newLoanProductId,
          );
          finleyAssert(
            newLoanProduct,
            `Loan product of id [${newLoanProductId}] not found`,
          );
          setLoanProduct(newLoanProduct);
        }
      }}
      isDisabled={!lpToCfEntityGrouping}
    />
  );
};
